import React, { Component } from 'react';
import SidebarMenuComponent from '../SidebarMenu/SidebarMenu';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import FoundationsComponent from '../Foundations/Foundations';
import FoundationDetailComponent from '../FoundationDetail/FoundationDetail';
import FoundationExtractComponent from '../FoundationDetail/FoundationExtract';
import DashboardComponent from '../Dashboard/Dashboard';
import DashboardRetentionComponent from '../DashboardRetention/DashboardRetention';
import EnterprisesComponent from '../Enterprises/Enterprises';
import EnterpriseDetailComponent from '../EnterpriseDetail/EnterpriseDetail';
import EnterprisePaymentsComponent from '../EnterprisePayments/EnterprisePayments';
import EnterprisePaymentDetailComponent from '../EnterprisePaymentDetail/EnterprisePaymentDetail';
import UsersComponent from '../Users/Users';
import UserDetailComponent from '../UserDetail/UserDetail';
import FoundationPaymentsComponent from '../FoundationPayments/FoundationPayments';
import FoundationSuscriptionsComponent from '../Foundations/FoundationSuscriptions';
import FoundationPaymentDetailComponent from '../FoundationPaymentDetail/FoundationPaymentDetail';
import BlogComponent from '../Blog/Blog';
import BlogArticleComponent from '../BlogArticle/BlogArticle';
import AdminsComponent from '../Admins/Admins';
import AccountingComponent from '../Accounting/Accounting';
import PaymentsComponent from '../Payments/Payments';
import GroupedPaymentsComponent from '../Payments/GroupedPayments';
import ProgramsComponent from '../Programs/Programs';
import NibifyComponent from '../Nibify/NibifyComponent';
import './styles/styles.scss';

class HomeComponent extends Component {

  render() {

    return (
      <div className="home-component">
        <Router>
          <Route render={props => <SidebarMenuComponent {...props} />} />

          <div className="app-content">
            <Switch>

              <Route path="/fundaciones/programas" render={props => <ProgramsComponent {...props} />} />

              <Route path="/fundaciones/desembolsos/:id" render={props =>
                <FoundationPaymentDetailComponent id={props.match.params.id} {...props} />}
              />
              <Route path="/fundaciones/desembolsos" render={props => <FoundationPaymentsComponent {...props} />} />

              <Route path="/fundaciones/:id" render={props =>
                <FoundationDetailComponent id={props.match.params.id} {...props} />}
              />
              <Route path="/extractos_fundaciones/:id" render={props =>
                <FoundationExtractComponent id={props.match.params.id} {...props} />}
              />

              <Route path="/comercios/desembolsos/:id" render={props =>
                <EnterprisePaymentDetailComponent id={props.match.params.id} {...props} />}
              />
              <Route path="/comercios/desembolsos" render={props => <EnterprisePaymentsComponent {...props} />} />

              <Route path="/comercios/:id" render={props =>
                <EnterpriseDetailComponent id={props.match.params.id} {...props} />}
              />

              <Route path="/usuarios/:id" render={props =>
                <UserDetailComponent id={props.match.params.id} {...props} />}
              />

              <Route path="/usuarios" render={props => <UsersComponent {...props} />} />
              <Route path="/fundaciones" render={props => <FoundationsComponent {...props} />} />
              <Route path="/nibify" render={props => <NibifyComponent {...props} />} />
              <Route path="/comercios" render={props => <EnterprisesComponent {...props} />} />
              <Route path="/contabilidad" render={props => <AccountingComponent {...props} />} />

              <Route path="/pagos/agrupado" render={props => <GroupedPaymentsComponent {...props} />} />
              <Route path="/pagos/suscripciones" render={props => <FoundationSuscriptionsComponent {...props} />} />
              <Route path="/pagos" render={props => <PaymentsComponent {...props} />} />

              <Route path="/blog/nuevo" render={props => <BlogArticleComponent {...props} />} />
              <Route path="/blog/:id" render={props =>
                <BlogArticleComponent id={props.match.params.id} {...props} />}
              />
              <Route path="/blog" render={props => <BlogComponent {...props} />} />

              <Route path="/admin">
                <AdminsComponent />
              </Route>

              <Route path="/dashboard/retention" render={props => <DashboardRetentionComponent {...props} />} />

              <Route path="/">
                <DashboardComponent />
              </Route>

            </Switch>
          </div>
        </Router>
      </div>
    );
  }
}

export default HomeComponent;
